import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    {{renderValue}}
  `,
})
export class PasswordRenderComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    // console.log('[PasswordRenderComponent] Value=' + this.value);
    this.renderValue = '*'.repeat(this.value.length);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/password-renderer.ts